import React, { useState } from 'react';
import { Bell, BellDot } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useComprehensiveNotifications } from '@/hooks/useComprehensiveNotifications';
import ComprehensiveNotificationsList from './ComprehensiveNotificationsList';

const ComprehensiveNotificationBell = () => {
  const { notifications, unreadCount, loading } = useComprehensiveNotifications();
  const [isOpen, setIsOpen] = useState(false);
  
  const hasUnread = unreadCount > 0;

  console.log('🔔 Comprehensive NotificationBell - Unread count:', unreadCount, 'Total:', notifications.length);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="relative w-12 h-12">
          {hasUnread ? (
            <BellDot className="h-7 w-7 text-red-500 animate-pulse" />
          ) : (
            <Bell className="h-7 w-7 text-gray-400 hover:text-sports-green transition-colors" />
          )}
          {hasUnread && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-6 w-6 flex items-center justify-center font-bold animate-pulse">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-96 bg-gray-800 border-gray-700">
        <ComprehensiveNotificationsList 
          onClose={() => setIsOpen(false)} 
          loading={loading}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ComprehensiveNotificationBell;